import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { CustomerOffer } from "./customer-offer.model";

export const ACTION_PREFIX = "[Customer Offer]";

export const CUSTOMER_OFFER_ACTION_TYPE = {
	setEnabled: `${ACTION_PREFIX} Set Enabled ${SYNC_SUFFIX}`,

	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	getVisitorOffers: `${ACTION_PREFIX} Get Visitor Offers`,
	getVisitorOffersSuccess: `${ACTION_PREFIX} Get Visitor Offers Success`,
	getVisitorOffersFail: `${ACTION_PREFIX} Get Visitor Offers Fail`,

	clearVisitorOffers: `${ACTION_PREFIX} Clear Visitor Offers ${SYNC_SUFFIX}`,
	clearCustomerOffers: `${ACTION_PREFIX} Clear Customer Offers ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class CustomerOfferAction {
	setEnabled(isEnabled: boolean): ActionWithPayload {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.setEnabled,
			payload: isEnabled,
		};
	}

	get(): Action {
		return createCachedGetAction({
			type: CUSTOMER_OFFER_ACTION_TYPE.get,
		});
	}

	getSuccess(payload: CustomerOffer[]): ActionWithPayload {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(error: AppError | Error): ActionWithPayload {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.getFail,
			payload: error,
		};
	}

	getVisitorOffers(): Action {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.getVisitorOffers,
		};
	}

	getVisitorOffersSuccess(payload: CustomerOffer[]): ActionWithPayload {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.getVisitorOffersSuccess,
			payload,
		};
	}

	getVisitorOffersFail(error: AppError | Error): ActionWithPayload {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.getVisitorOffersFail,
			payload: error,
		};
	}

	clearVisitorOffers(): Action {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.clearVisitorOffers,
		};
	}

	clearCustomerOffers(): Action {
		return {
			type: CUSTOMER_OFFER_ACTION_TYPE.clearCustomerOffers,
		};
	}
}
